import styled, {keyframes} from "styled-components";
import {CharcoalBlack, DarkSlate, GreyIce, Teal, White, ErrorRed} from "../../../theme/variable";
import {media} from "../../../theme/responsive.js";
import {ErrorHelperText} from "../../HTMLEntities/Textfield/widgets/Styled";
import {validateField} from "../../../utils/validation";
import registration_sprite from "../../../images/registration_sprite.svg";
import TopBand from "../../../images/Topband.svg";
import googlePromptSprite from "../../../images/googlePromptSprite.svg";
import locationIcon from "../../../images/location_icon.svg";

export const blink = keyframes`
0% {
    opacity: .2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .2;
  }
`;

// export const TabsContainer = styled.div`
//   display: flex;
//   flex-direction: row;
//   flex-wrap: wrap;
//   position: relative;
//   padding: 0;
//   max-width: 100%;
//   [name="radiotabs"] {
//     position: absolute;
//     visibility: hidden;
//   }
//   [id^="tab-label"] {
//     position: relative;
//     top: 0px;
//     max-height: 18px;
//     margin: 4px 2px 0 0;
//     display: inline-block;
//     padding: 12px 21px;
//     font-size: 12px;
//     font-weight: bold;
//     text-transform: uppercase;
//     background: #fff;
//     cursor: pointer;
//     transition: all 0.2s ease-in-out;
//   }
//   #tab1 {
//     -webkit-box-ordinal-group: 2;
//     -webkit-order: 1;
//     -ms-flex-order: 1;
//     order: 1;
//   }
//   #tab2 {
//     -webkit-box-ordinal-group: 3;
//     -webkit-order: 2;
//     -ms-flex-order: 2;
//     order: 2;
//   }
//   > [id^="tab-content"] {
//     -webkit-box-ordinal-group: 999;
//     -webkit-order: 999;
//     -ms-flex-order: 999;
//     order: 999;
//     display: none;
//     z-index: 2;
//     top: 48px;
//     width: 100%;
//     min-height: 5em;
//     overflow: hidden;
//     font-size: 14px;
//     border-width: 1px;
//     border-style: solid;
//     padding: 10px 25px 25px 25px;
//     background: #fff;
//     margin-top: -1px;
//     border-radius: 0 5px 5px 5px;
//     border-color: transparent;
//   }
//   [name="radiotabs"]:checked + [id^="tab-label"] {
//     z-index: 4;
//     margin-top: 0px;
//     padding-top: 16px;
//     background: #c9c9c9;
//     border-color: #000 #000 #c9c9c9 #000;
//   }
//   #tab1:checked ~ #tab-content1 {
//     display: block;
//   }
//   #tab2:checked ~ #tab-content2 {
//     display: block;
//   }
// `;
// export const TabSection = styled.div``;

export const TabsHeader = styled.div`
    width: 100%;
    border-bottom: 1px solid ${Teal};
    padding: 0;
    margin: 0 auto;
    text-align: center;
    label {
        display: inline-block;
        padding: 16px 48px;
        font-weight: 400;
        color: ${CharcoalBlack};
        font-size: 1rem;
        border-bottom: 4px solid #ffffff;
        cursor: pointer;
        &.active {
            font-weight: 600;
            border-bottom: 4px solid ${Teal};
            color: ${Teal};
        }
    }
`;
export const TabsSection = styled.div`
    margin-top: 28px;
    position: relative;
    h2 {
        font-size: 1.25rem;
        line-height: 28px;
        display: block;
    }
    span {
        color: ${DarkSlate};
        font-size: 0.75rem;
        line-height: 18px;
        margin-top: 4px;
        display: inline-block;
        ${media.laptop`display:unset;margin-top:0;`}
    }
`;
export const OrSection = styled.div`
    border-bottom: 1px solid ${GreyIce};
    margin: 16px 0 0;
    position: relative;
    width: 100%;
    && span {
        width: 50px;
        background: #fff;
        display: inline-block;
        position: absolute;
        bottom: -12px;
        left: 50%;
        text-align: center;
        color: ${DarkSlate};
        transform: translateX(-50%);
    }
`;
export const TabFormSection = styled.div`
    width: ${(props) => (props.LoginformDiv ? "330px" : "100%")};
    margin: ${(props) => (props.LoginformDiv ? "18px auto" : "12px 0 0 0")};
    text-align: ${(props) => (props.LoginformDiv ? "center" : "")};
`;
export const MobileNumberSection = styled.div`
    width: 100%;
    display: inline-flex;
    align-items: flex-end;
    justify-content: space-between;
    > div:first-child {
        margin-top: 10px;
    }
`;
export const HelperText = styled.span`
    display: block;
    color: ${DarkSlate};
    margin-bottom: 0px;
    ${media.laptop`margin-bottom: 0px;position:absolute;top:66px;left:0;`}
`;
export const SelectHelperText = styled.span`
    display: block;
    color: ${DarkSlate};
    top: -5px;
    position: relative;
    ${media.laptop``}
`;
export const WithTitleField = styled.div`
    width: 100%;
    position: relative;
    top: 10px;
    strong {
        font-weight: 600;
        font-size: 1.0625rem;
        line-height: 27px;
        color: ${CharcoalBlack};
        margin-bottom: 5px;
        span {
            font-weight: 400;
        }
    }
    h3 {
        font-size: 1.0625rem;
        line-height: 22px;
        margin-bottom: ${(props) => (props.titleFieldOnLayer ? "4px" : "4px")};
        ${media.laptop`margin-bottom:0px;line-height: 27px;`}
    }
    h4 {
        font-size: 0.9375rem;
        line-height: 24px;
    }
`;
export const RangeTextInputDiv = styled.div`
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
`;
export const RadioGroupSection = styled.div`
    width: 100%;
    > div {
        width: 30%;
        &:last-child {
            width: 28%;
        }
    }
`;
export const ExamScoreInput = styled.div`
    display: inline-block;
    width: ${(props) => (props.isMobilePopup ? "25%" : "41%")};
    input[type=number] {
        -moz-appearance:textfield;
    }
    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }    
    ${media.laptop`width: 39%`}
}}
`;
export const ExamScoreDiv = styled.div`
    width: ${(props) => (props.isMobilePopup ? "100%" : "50%")};
    display: inline-flex;
    align-items: center;
    position: relative;
    border-bottom: ${(props) => (props.isMobilePopup ? "1px solid #eee" : "")};
    > div:first-child {
        margin-right: 5px;
        width: ${(props) => (props.isMobilePopup ? "72%" : "78px")};
        ${media.laptop`width: auto;margin-right:18px;`}
    }
    &:nth-child(3),
    &:nth-child(5) {
        > ${ExamScoreInput} > div > ${ErrorHelperText} {
            width: 200px;
            left: -15px;
            ${media.laptop`width:160px;left:47%;`}
        }
        > ${ExamScoreInput} > div > ${ErrorHelperText}:before {
            right: 49px;
            left: auto;
            ${media.laptop`right:auto;left:42%;`}
        }
    }
    ${media.laptop`width: 25%;position:unset;border-bottom:none;`}
`;
export const DisclaimerDiv = styled.div`
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    margin-top: 10px;
    position: relative;
    label {
        cursor: pointer;
        font-size: 0.75rem;
        font-weight: 400;
        margin-left: 5px;
        -webkit-tap-highlight-color: transparent;
    }
`;
export const SignUpButtonArea = styled.div`
    text-align: center;
    width: 100%;
    margin: 20px auto 10px;
    z-index: ${(props) => (props.isSubmitting ? "10" : "")};
    position: ${(props) => (props.isSubmitting ? "relative" : "")};
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    button {
        min-width: 210px;
        font-size: 1.0625rem;
        min-height: 42px;
        height: auto;
        outline: none;
        width: auto;
        line-height: 24px;
        display: block;
        width: 255px;
        margin-bottom: 16px;
        :nth-child(2) {
            border: 1px solid ${Teal};
            line-height: 42px;
            ${media.laptop` line-height:40px;`}
        }
        ${media.laptop` height: 42px;line-height:40px;width:255px;margin-bottom:16px;`}
    }
    button > div {
        width: unset;
        min-width: unset;
        line-height: 40px;
        margin-bottom: 0;
    }
    div {
        min-width: 210px;
        font-size: 1.0625rem;
        min-height: 42px;
        height: auto;
        outline: none;
        width: auto;
        line-height: 24px;
        display: block;
        width: 255px;
        margin-bottom: 16px;
        :nth-child(2) {
            border: 1px solid ${Teal};
            line-height: 40px;
        }
        ${media.laptop` height: 42px;line-height:40px;width:255px;margin-bottom:16px;`}
    }
`;
export const LoginEllipsisAnimation = styled.div`
    font-size: 1.0625rem;
    & > span {
        animation-name: ${blink};
        animation-duration: 1.4s;
        animation-iteration-count: infinite;
        animation-fill-mode: both;
        width: 4px;
        height: 4px;
        display: inline-block;
        border-radius: 50%;
        background: #fff;
        margin: 0 2px;
        &:nth-child(2) {
            animation-delay: 0.2s;
        }
        &:nth-child(3) {
            animation-delay: 0.4s;
        }
    }
`;
export const HeaderDiv = styled.div`
    background: ${Teal};
    display: inline-flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    p {
        color: ${White};
        font-size: 1rem;
        line-height: 1.58;
        font-weight: 600;
        padding: 12px;
        width: 100%;
    }
    ${media.laptop`display:none;`}
`;
export const BackArrow = styled.div`
    padding: 12px;
`;
export const BackArrowIcon = styled.div`
    font-weight: 600;
    line-height: 31px;
    width: 10px;
    height: 10px;
    transform: rotate(-135deg);
    position: relative;
    top: 0px;
    left: 8px;
    border-style: solid;
    border-color: rgb(255, 255, 255);
    border-image: initial;
    border-width: 2px 2px 0px 0px;
`;

export const TopHeading = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    span {
        margin-top: 2px;
    }
    ${media.laptop`flex-direction:row;`}
`;

export const UniversityLogo = styled.div`
    width: 110px;
    height: 80px;
    text-align: center;
    border-radius: 4px;
    border: solid 1px #666666;
    background-color: #ffffff;
    margin: 0 0 16px 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    img {
        height: auto;
        display: inline-block;
        position: absolute;
        left: 0;
        right: 0;
        z-index: 2;
    }
    ${media.laptop`align-self:flex-start; margin:0 12px 0 0`}
`;
export const LogoBlurImage = styled.div`
    background-image: url(${(props) => props.url});
    position: absolute;
    width: 108px;
    height: 80px;
    z-index: 1;
    left: 0;
    right: 0;
    filter: blur(8px);
`;

export const Content = styled.div`
    width: 100%;
    text-align: ${(props) => (props.isMMP ? "center" : "")};
    h1 {
        font-size: 1.5rem;
        line-height: 32px;
        font-weight: 600;
    }
    span {
        margin-top: 4px;
        display: inline-block;
        line-height: 1.4;
        ${media.laptop`margin-top:0; display:unset;`}
    }
    ${media.laptop`width: ${(props) => (props.headerImagePresent ? "calc(100% - 110px)" : "100%")}`}
`;

export const ExamScoreId = styled.input`
    display: none;
`;
export const RedirectionWrapper = styled.div`
    padding: 16px;
    strong {
        font-size: 1.25rem;
        line-height: 24px;
        display: block;
    }
    p {
        font-size: 0.875rem;
        margin-top: 20px;
    }
`;
export const LayerButtonArea = styled.div`
    text-align: center;
    margin-top: 37px;
    button {
        margin: 0 10px;
    }
`;
export const FormLevelErrorField = styled.p`
    &&& {
        color: ${ErrorRed};
        font-size: 0.875rem;
        font-weight: 400;
        text-align: center;
    }
`;
export const ExamFormDiv = styled.div`
    width: 100%;
    margin-top: 16px;
    ul > li > h3 {
        margin-bottom: 8px;
    }
    ${RadioGroupSection} {
        width: 100%;
        ${media.laptop`width: 60%;`};
    }
`;
export const FormUl = styled.ul`
    && {
        display: ${(props) =>
            validateField(props.type) && props.type === "login" ? "block" : "inline-flex"};
        padding: 0;
        width: 100%;
        justify-content: space-between;
        flex-flow: wrap;
    }
`;
export const FormUlList = styled.li`
    && {
        list-style: none;
        width: 100%;
        margin-bottom: 0px;
        ${media.laptop`position:relative; 
        width: ${(props) => (props.fullWidthDiv === true ? "100%" : "48%")}`};
    }
    button.loginButton--google {
        background: #4285f4;
        height: 42px;
        line-height: 42px;
        border-radius: 4px;
        text-align: center;
        font-size: 1.0625rem;
        line-height: 18px;
        font-weight: 600;
        color: ${White};
        border: none;
        padding: 0 18px 0 7px;
        width: 255px;
        cursor: pointer;
        &:before {
            content: "";
            background: url(${registration_sprite}) no-repeat;
            width: 30px;
            height: 30px;
            background-position: -1px -1px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 8px;
        }
    }
`;

export const OnSubmitFadedLoader = styled.div`
    background: rgba(255, 255, 255, 0.9);
    width: 100%;
    height: 98%;
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 8px;
`;
export const EditProfileUserPhoto = styled.div`
    width: 100%;
    display: inline-block;
    border-radius: ${(props) => (props.consentFormStyle ? "4px" : "50%")};
    text-align: ${(props) => (props.consentFormStyle ? "left" : "center")};
    padding-top: ${(props) => (props.consentFormStyle ? "0px" : "24px")};
    position: ${(props) => (props.consentFormStyle ? "relative" : "")};
    img {
        width: ${(props) => (props.consentFormStyle ? "42px" : "80px")};
        height: ${(props) => (props.consentFormStyle ? "42px" : "80px")};
        border-radius: ${(props) => (props.consentFormStyle ? "4px" : "50%")};
        display: inline-block;
        border: ${(props) => (props.consentFormStyle ? "1px solid #666" : "1px solid #eee")};
    }
`;
export const AddPhotoLink = styled.div`
    text-align: center;
    display: inline-flex;
`;

export const UserImageLinkSection = styled.div`
    width: ${(props) => (props.consentFormStyle ? "auto" : "100%")};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${(props) => (props.consentFormStyle ? "space-between" : "center")};
    font-size: 0.875rem;
`;
export const RemoveDiv = styled.div`
    color: ${Teal};
    font-size: 0.9375rem;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    position: ${(props) => (props.hideAddChangeButton ? "absolute" : "")};
    top: ${(props) => (props.hideAddChangeButton ? "21%" : "")};
    right: ${(props) => (props.hideAddChangeButton ? "0" : "")};
    &:before {
        content: ${(props) => (props.hideAddChangeButton ? "" : "''")};
        border-left: 1px solid ${DarkSlate};
        height: 10px;
        margin: 0 8px;
        display: inline-block;
    }
`;

export const ChangePasswordLink = styled.div`
    border: 1px solid ${Teal};
    padding: 10px;
    border-radius: 4px;
    margin-top: 2px;
    ${media.laptop`margin-top: 15px;`};
`;
export const ContentTopHeadImage = styled.div`
    background: url(${TopBand}) no-repeat;
    width: 195px;
    height: 141px;
    vertical-align: middle;
    margin: 16px 0 0 0;
    ${media.laptop` 
    margin-right:16px;
    margin-bottom:0; 
    width:277px;`}
`;
export const LoginTabContent = styled.div`
    text-align: center;
`;
export const RegToastMessageGradient = styled.div`
    background-image: ${(props) =>
        props.removeGradient
            ? `unset`
            : `linear-gradient(
        rgba(255, 255, 255, 0.6) 0%,
        rgb(255, 255, 255) 100%
    )`};
    width: 100%;
    height: ${(props) => (props.removeGradient ? "auto" : " 58%")};
    top: ${(props) => (props.removeGradient ? "42px" : "0")};
    position: absolute;
    z-index: ${(props) => (props.removeGradient ? "" : "1")};
    ${media.laptop`height: ${(props) => (props.removeGradient ? "auto" : "65%")};`};
`;
export const RegToastMessage = styled.div`
    background: rgb(66, 133, 244);
    border-radius: 4px;
    color: ${White};
    padding: 10px 12px;
    position: absolute;
    z-index: 2;
    left: 50%;
    transform: translate(-50%, -50%);
    // min-width: 270px;
    top: 85%;
    ${media.laptop` top: 77%;`};
    p {
        display: flex;
        flex-direction: row;
        max-width: 355px;
        min-width: 285px;
        ${media.laptop`align-items:center;`};
        span {
            font-size: 0.875rem;
            color: ${White};
            margin: 0;
        }
        &:before {
            content: "";
            background: url(${registration_sprite}) no-repeat;
            width: 33px;
            height: 24px;
            background-position: -223px -62px;
            padding-right: 10px;
            position: relative;
            top: 5px;
            ${media.laptop` position: unset;top: 0;width:24px;`};
        }
    }
`;
export const TriangleTip = styled.div`
    background: rgb(66, 133, 244);
    position: absolute;
    width: 14px;
    height: 12px;
    border-top-right-radius: 30%;
    transform: rotate(120deg) skewX(-30deg) scale(1, 0.866);
    bottom: -5px;
    left: 47%;
    &:after,
    &:before {
        content: "";
        position: absolute;
        width: 4px;
        height: 4px;
        border-top-right-radius: 34%;
        transform: rotate(135deg) skewY(-45deg) scale(0.707, 1.414) translate(50%);
    }
    &:before {
        transform: rotate(-135deg) skewX(-45deg) scale(1.414, 0.707) translate(0, -50%);
    }
`;
export const CrossIcon = styled.div`
    position: absolute;
    background: ${White};
    color: ${CharcoalBlack};
    border: 1px solid ${CharcoalBlack};
    border-radius: 50%;
    width: 28px;
    top: -16px;
    height: 28px;
    text-align: center;
    font-size: 22px;
    line-height: 26px;
    right: -10px;
    cursor: pointer;
`;
export const FormLevelErrorDiv = styled.div`
    margin: 20px 0 0;
    p {
        margin-bottom: 0;
    }
`;

export const GoogleSignupPromptDiv = styled.div`
    background-image: linear-gradient(
        to bottom,
        rgba(1, 3, 19, 0.8) 2%,
        #010313 14%,
        #010313 52%,
        rgba(0, 0, 0, 0.79)
    );
    display: flex;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    z-index: 9;
`;
export const GoogleSignupPromptDivContent = styled.div`
    position: relative;
    transform: translate(0px, -120px);
    padding: 0 20px;
    ${media.laptop`transform: translateX(-280px);padding:0`};
`;
export const ArrowPointerBox = styled.div`
    position: absolute;
    background: transparent;
    left: 50%;
    overflow: hidden;
    bottom: -50px;
    width: 26px;
    height: 35px;
    ${media.laptop`
        height: 150px;
        width: 524px;
        bottom: 100%;
        `};
`;
export const ArrowCurve = styled.div`
    transform: rotate(90deg);
    width: 60px;
    height: 50px;
    border-radius: 100px/85px;
    left: -35px;
    top: -20px;
    transform: rotate(90deg);
    border: 2px solid #ffbc00;
    position: relative;

    &:after {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        border: 2px solid #ffbc00;
        border-color: #ffbc00 #ffbc00 transparent transparent;
        position: absolute;
        transform: rotate(94deg);
        top: 6px;
        left: 46px;
        ${media.laptop`
            right: 22.5px;
            top: 76px;
            left:auto;`}
    }
    ${media.laptop`
        width: 750px;
        height: 300px;
        background: transparent;
        border-radius: 1000px / 370px;   
        transform:rotate(-27deg);     
        left: -136px;
        top: 76px;
        `}
`;
export const GoogleSignupContentWrapper = styled.div`
    ${media.laptop` margin-top: 10px;`}
`;
export const GooglePromptHead = styled.strong`
    font-size: 1.375rem;
    font-weight: 600;
    line-height: 1.27;
    color: ${White};
    ${media.laptop`font-size: 1.5rem;`}
`;
export const GooglePromptList = styled.ul`
    list-style: none;
`;
export const GooglePromptListItems = styled.li`
    font-size: 0.8125rem;
    color: #fff;
    display: flex;
    align-items: center;
    margin: 16px 0;
    &:last-child {
        margin-bottom: 0;
    }
    ${media.laptop`font-size: 1rem;`}
`;
export const GooglePromptCollegeIcon = styled.i`
    background: url(${googlePromptSprite}) no-repeat;
    background-position: -4px -4px;
    display: inline-block;
    width: 24px;
    height: 24px;
    margin: 0 16px 0 0;
    transform: scale(1.2);
    ${media.laptop` transform: scale(1.4);`}
`;
export const GooglePromptExamIcon = styled(GooglePromptCollegeIcon)`
    background-position: -4px -38px;
`;
export const GooglePromptAdmissionIcon = styled(GooglePromptCollegeIcon)`
    background-position: -4px -79px;
`;
export const MobileNumberIcon = styled.i`
    background: #f1f1f1 url(${registration_sprite}) no-repeat;
    width: 25px;
    height: 25px;
    background-position: 3px -58px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
`;
export const MobileNumberSectionWrapper = styled.div`
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
`;
export const OTPButtonWrapper = styled.div`
    width: 100%;
    margin-top: 40px;
    button {
        width: 255px;
        font-size: 1.0625rem;
        min-height: 42px;
        height: auto;
    }
`;
export const M1LoginHeading = styled.div`
    font-size: 1.3rem;
    line-height: 32px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 14px;
`;

export const ContentUl = styled.ul`
    width: 100%;
    text-align: left;
    margin: 0 auto;
    ${media.laptop`  width: 80%;`}
`;

export const ChangeLocationWrapper = styled.div`
    width: 100%;
    margin: 6px 0;
    color: ${DarkSlate};
    font-size: 0.875rem;
    line-height: 21px;
    strong,
    span {
        display: inline-block;
        font-size: 0.875rem;
        line-height: 21px;
        color: ${CharcoalBlack};
        font-weight: 400;
    }
    span {
        color: ${Teal};
        cursor: pointer;
    }
`;
export const OrDiv = styled.div`
    color: #000000;
`;

export const CameraButton = styled.div`
    padding: 0px 12px 0px 13px;
    border-radius: 4px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14);
    border: solid 1px #cccccc;
    background-color: #ffffff;
    display: inline-block;
    height: 34px;
    line-height: 34px;
    cursor: pointer;
    color: #000000;
    text-align: center;
    font-weight: 400;
    vertical-align: middle;
    font-size: 0.875rem;
    width: auto;

    label {
        cursor: pointer;
    }
`;

export const ChangeLocationIcon = styled.i`
    width: 11px;
    height: 14px;
    background: url(${locationIcon});
    background-repeat: no-repeat;
    background-position: center center;
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    top: -2px;
`;
